// FileName: ProfilePage.js
import React from 'react';

function ProfilePage() {
  return <h1>Profile Page</h1>;
}

export default ProfilePage;